/**
 * Back to Top — Mostra/esconde botão e rola ao topo
 *
 * Some ao chegar no rodapé: dali pra baixo o próprio rodapé já tem o link
 * "Voltar ao topo" e o botão flutuante fica redundante — e, pior, ficava
 * por cima do texto de copyright e do crédito da Websites Já.
 *
 * O seletor era `.site-foot__mid`, que não existe no markup (o rodapé tem
 * `__top` e `__bot`). Sem elemento, o observer nunca era criado e o botão
 * nunca sumia — sem erro nenhum no console.
 */
$(function () {
    var $backTop = $('#backToTop');

    if (!$backTop.length) return;

    var rodape = document.querySelector('.site-foot');
    var noRodape = false;

    // Mostra/esconde com scroll — e nunca por cima do rodapé
    function atualiza() {
        $backTop.toggleClass('visible', $(window).scrollTop() > 400 && !noRodape);
    }

    $(window).on('scroll', atualiza);

    if (rodape && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
            noRodape = entradas[0].isIntersecting;
            atualiza();
        }).observe(rodape);
    }

    // Click — rola ao topo
    $backTop.on('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});
